import { createSlice } from "@reduxjs/toolkit";
// this code for slice value for  edit map strategy
export const EditMapStrategies = createSlice({
  name: "EditMapStrategies",
  initialState: {
    isLoading: false,
    isSuccess: false,
    api_completed: false,
    isFirst: true,
    switchResponse: false,
    data: [],
  },
  reducers: {
    edit_EditMapStrategies: (state, _) => {
      state.isLoading = true;
    },
    success_api_call_EditMapStrategies: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
      state.isSuccess = true;
      state.api_completed = true;
      state.isFirst = true;
      state.switchResponse = true;
    },
    failure_api_call_EditMapStrategies: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.api_completed = true;
      state.isSuccess = false;
      state.switchResponse = true;
    },
    EditMapStrategies_is_success: (state) => {
      state.isSuccess = false;
    },
    EditMapStrategies_complete_api: (state) => {
      state.api_completed = false;
    },
    clear_edit_Data: (state) => {
      state.data = [];
    },
    false_switchmap_response: (state) => {
      state.switchResponse = false;
    },
  },
});
export default EditMapStrategies.reducer;
export const {
  edit_EditMapStrategies,
  success_api_call_EditMapStrategies,
  EditMapStrategies_complete_api,
  failure_api_call_EditMapStrategies,
  EditMapStrategies_is_success,
  clear_edit_Data
  ,false_switchmap_response
} = EditMapStrategies.actions;
